import { createContext, useContext, useState } from 'react';
import translations from '../lib/translations';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('euromoto_lang');
    return saved || 'en';
  });

  const changeLang = (code) => {
    setLang(code);
    localStorage.setItem('euromoto_lang', code);
  };

  const t = (path) => {
    const keys = path.split('.');
    let val = translations[lang];
    for (const k of keys) {
      val = val?.[k];
    }
    if (val === undefined) {
      let fallback = translations['en'];
      for (const k of keys) {
        fallback = fallback?.[k];
      }
      return fallback || path;
    }
    return val;
  };

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be inside LanguageProvider');
  return ctx;
}
